import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
  },
  {
    path: '/',
    name: 'index',
    redirect: '/',
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/',
        name: 'index',
        component: () => import('@/views/index.vue'),
        meta: { level: '1' }
      }
    ]
  },
  {
    path: '/IndutryNews',
    name: 'IndutryNews',
    redirect: '/IndutryNews',
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/IndutryNews',
        name: 'IndutryNews',
        redirect: '/IndutryNews/list',
        component: () => import('@/views/IndutryNews/index.vue'),
        meta: { level: '2' },
        children: [
          {
            path: 'list',
            name: 'list',
            component: () => import('@/views/IndutryNews/list.vue'),
            meta: { level: '2-1' },
          },
          {
            path: 'details',
            name: 'details',
            component: () => import('@/views/IndutryNews/details.vue'),
            meta: { level: '2-2' },
          }
        ]
      }
    ]
  },
  {
    path: '/Production',
    name: 'Production',
    redirect: '/Production',
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/Production',
        name: 'Production',
        component: () => import('@/views/Production/index.vue'),
        meta: { level: '3' }
      }
    ]
  },
  {
    path: '/ByModels',
    name: 'ByModels',
    redirect: '/ByModels',
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/ByModels',
        name: 'ByModels',
        component: () => import('@/views/ByModels/index.vue'),
        meta: { level: '4' }
      }
    ]
  },
  {
    path: '/data/dataTable',
    name: 'data',
    redirect: '/data/dataTable',
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/data/dataTable',
        name: 'data',
        component: () => import('@/views/data/list.vue'),
        meta: { level: '5'}
      }]
  },
  {
    path: "/data/dataTable/qccxhzb/:date",
    name: "汽车(分车型)产销汇总表",
    component: () => import('@/views/data/dataTable/qccxhzb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/cychzb/:date",
    name: "乘用车产销汇总表",
    component: () => import('@/views/data/dataTable/cychzb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/sychzb/:date",
    name: "商用车产销汇总表",
    component: () => import('@/views/data/dataTable/sychzb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/qgcyczyppcxqkb/:date/:bj2",
    name: "全国乘用车主要品牌产销情况表",
    component: () => import('@/views/data/dataTable/qgcyczyppcxqkb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/wdqcqycyc/:date",
    name: "五大汽车企业集团乘用车产销情况表",
    component: () => import('@/views/data/dataTable/wdqcqycyc'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/wdqcqysyc/:date",
    name: "五大汽车企业集团商用车产销情况表",
    component: () => import('@/views/data/dataTable/wdqcqysyc'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/fdjscqy/:date",
    name: "发动机生产企业产销情况表 (台)",
    component: () => import('@/views/data/dataTable/fdjscqy'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/cycfcxcxqkb/:date",
    name: "乘用车(分车型)产销情况表",
    component: () => import('@/views/data/dataTable/cycfcxcxqkb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/cycscqycxqkb/:date",
    name: "乘用车生产企业产销情况表",
    component: () => import('@/views/data/dataTable/cycscqycxqkb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/sycscqycxqkb/:date",
    name: "商用车生产企业产销情况表",
    component: () => import('@/views/data/dataTable/sycscqycxqkb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/scqycxqkb/:date/:bj4",
    name: "生产企业产销情况表",
    component: () => import('@/views/data/dataTable/scqycxqkb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/qcfdjarlflscqyqkb/:date",
    name: "汽车发动机(按燃料分类)生产企业产销情况表 (台)",
    component: () => import('@/views/data/dataTable/qcfdjarlflscqyqkb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/xnyqccxqkb/:date",
    name: "新能源汽车产销情况表",
    component: () => import('@/views/data/dataTable/xnyqccxqkb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/bgqycfcxcxhzb/:date",
    name: "半挂牵引车(分车型)产销汇总表",
    component: () => import('@/views/data/dataTable/bgqycfcxcxhzb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/qcfqyckqkb/:date",
    name: "汽车分企业出口情况表",
    component: () => import('@/views/data/dataTable/qcfqyckqkb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/qcsczyqycxqkb/:date",
    name: "汽车生产主要企业产销情况表",
    component: () => import('@/views/data/dataTable/qcsczyqycxqkb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/xnysyccyc/:date/:bj1",
    name: "新能源商用车乘用车",
    component: () => import('@/views/data/dataTable/xnysyccyc'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/frlclfcxcxb/:date/:bj4",
    name: "分燃料分车型产销情况表",
    component: () => import('@/views/data/dataTable/frlclfcxcxb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/zhcfdwcxqkb/:date",
    name: "载货车(分吨位)产销情况表",
    component: () => import('@/views/data/dataTable/zhcfdwcxqkb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/zhcfytcxqkb/:date",
    name: "载货车(分用途)产销情况表",
    component: () => import('@/views/data/dataTable/zhcfytcxqkb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/getHcfwzclscqycxqkb/:date",
    name: "货车非完整车辆生产企业产销情况表",
    component: () => import('@/views/data/dataTable/getHcfwzclscqycxqkb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/getBgqycscqycxqkb/:date",
    name: "半挂牵引车生产企业产销情况表",
    component: () => import('@/views/data/dataTable/getBgqycscqycxqkb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/getKcfcxCxqkb/:date",
    name: "客车(分车型)产销情况表",
    component: () => import('@/views/data/dataTable/getKcfcxCxqkb'),
    meta: {
      hidden: 1,
    },
  },
  {
    path: "/data/dataTable/getZhcfcxCxqkb/:date",
    name: "载货车(分车型)产销情况表",
    component: () => import('@/views/data/dataTable/getZhcfcxCxqkb'),
    meta: {
      hidden: 1,
    },
  },

  {
    path: '/404',
    name: 'index',
    component: () => import('@/layout/index.vue'),
    redirect: '/404',
    children: [
      {
        path: '/404',
        component: () => import('@/views/error-page/404'),
        name: '404',
      },
    ]
  },
  {
    path: '*', redirect: '/404'
  }
]

const router = new VueRouter({
  routes
})

export default router
